import React from 'react'

type Props = React.SVGProps<SVGSVGElement>

export function ArrowRight(props: Props) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M0.41432 9.89954C0.41432 9.34725 0.861929 8.89965 1.41421 8.89965H15.9707L11.3137 4.24269C10.9232 3.85217 10.9232 3.21899 11.3137 2.82847C11.7042 2.43796 12.3374 2.43799 12.7279 2.82847L19.0919 9.19243C19.1163 9.21689 19.1395 9.24215 19.1609 9.26839C19.1822 9.29443 19.2014 9.32162 19.2196 9.34918C19.2564 9.40477 19.2877 9.46285 19.3122 9.5232C19.4097 9.76385 19.4097 10.0352 19.3122 10.2759C19.2877 10.3362 19.2564 10.3943 19.2196 10.4499C19.2014 10.4775 19.1822 10.5046 19.1609 10.5307C19.1395 10.5569 19.1163 10.5822 19.0919 10.6066L12.7279 16.9706C12.3374 17.3611 11.7042 17.3611 11.3137 16.9706C10.9232 16.5801 10.9232 15.9469 11.3137 15.5564L15.9707 10.8994H1.41421C0.861929 10.8994 0.41432 10.4518 0.41432 9.89954Z"
        fill="white"
      />
    </svg>
  )
}
